const PREFIX = "AUTH"
const AUTH_TYPES = {
  LOGIN: `${PREFIX}/LOGIN`,
  LOGOUT: `${PREFIX}/LOGOUT`,
  UPDATE_USERDATA: `${PREFIX}/UPDATE_USERDATA`
}

export default AUTH_TYPES